import { EnvironmentConfig } from './environment.interface';

export const environment: EnvironmentConfig = {
  production: false,
  envName: 'test',

  api: {
    web: {
      baseUrl: 'https://api.ticketexitotest.apps-ecualatino.dev/admin',
      apiKey: 'b5f45f4ae788360def827ef7a6331220a5318dd2243e07535e6dd314a6486bbf',
    },
    mobile: {
      baseUrl: 'https://api.ticketexitotest.apps-ecualatino.dev/appmanager',
      apiKey: '9f3c2e8a6b1d4f5c7e8a9b0c1d2e3f4a5b6c7d8e9f00112233445566778899aa',
    },
  },

  amplify: {
    graphqlEndpoint: 'https://connect.ticketexitotest.apps-ecualatino.dev',
    region: 'us-east-1',
    apiKey: 'da2-i6jfrrhjp5amzkhp2gbktmv7zy',
  },

  cloudflare: {
    turnstileSiteKey: '0x4AAAAAACZumBzT7VZkWBUg',
    turnstileSecretKey: '0x4AAAAAACZumG0hYHAobfwFuCKcwi_5OXs',
  },
};
